import React, { useEffect, useState , useMemo} from "react";
import { useDispatch, useSelector } from "react-redux";
import { setRegionActions } from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import RegionCreateFrom from "./RegionCreateFrom";
import Delete from "../../AppComponent/Popup/Delete";
import {
  setRegionDeleteActions,
  getSideBarfilesActions,
  setGeoLoactionStateAction,
  setTablePositionPersist
} from "../../../Redux/Slice";
import { NavLink } from "react-router-dom";
import Select from "react-select";
import _ from "lodash";
import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import useDebouncedEffect from 'use-debounced-effect';


const Region = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
 const TablePositionPersist = useSelector(state=>state.PreviousPagePosition.TablePositionPersist)

  const dispatch = useDispatch();
  const State = useSelector((state) => state);

const [dtpageindex, setdtPageindex] = useState(
    TablePositionPersist?.Overall_RegionDatas?.page == undefined
      ? 1
      : TablePositionPersist.Overall_RegionDatas.page
  );

  const [dtpagesize, setdtPagesize] = useState(10);
  const [pageSize, setPageSize] = useState(20);
const [search,setsearch] = useState(
    TablePositionPersist?.Overall_RegionDatas?.search == undefined ||
    TablePositionPersist?.Overall_RegionDatas?.search == ""
      ? ''
      : TablePositionPersist?.Overall_RegionDatas?.search
  ); 

  const [currentPage, setCurrentPage] = useState(1);
  const [Data, setdatas] = useState([]);
  const [newpages, setNewpage] = useState(1);
  const [CreateRegions, setCreateRegion] = useState(false);
  const [DeletePOPUP, setDeletePOPUP] = useState(false);
  const [DeleteID, setDeleteID] = useState("");
  const [EditId, setEditID] = useState();
  const [data, setData] = useState({ zone: "",     state: State.ClientBranchIDs.StateName.value    , region: "" });
  let [nameList, setOptions] = useState([]);

  const initialStateSearch = {
    stateSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);

  const initialDebouanceSearch = {
    stateSearch: "",
  };

const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);
useDebouncedEffect(
  () => {
      if (setSearchDebounance) {
          setSearched({
              ...SearchedVal,
              stateSearch: SearchDebounance.stateSearch,
          });
      }
  },
  500,
  [SearchDebounance]
);


  ///-----State----Input Changes
  const handleInputChange = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        stateSearch: Val,
    });
};

  const [multiselect, setMuliselect] = useState([
    //  { value: "", label: "All" }
    State.ClientBranchIDs.StateName,
  ]);

  useEffect(() => {
    const payloads = {
      search: search,
      page_size: 20,
      page: dtpageindex,
      state: data.state,
    };
    dispatch(setRegionActions(payloads));
       dispatch(
              setTablePositionPersist({ data: payloads, pageName: "Overall_RegionDatas" })
            );
    

    setdatas(State.regioncall.RegionDat);
  }, [dtpageindex, data]);
  const HandelDelete = () => {
              setdtPageindex(1)
         const payloads_tocall = {
          search: "",
          page_size: 20,
          page: 1,
          };
          dispatch(setTablePositionPersist({data:payloads_tocall,pageName:"Overall_RegionDatas"}))
    

    if (DeleteID != undefined) {
      console.log(currentPage, "sdsd");
      const payload = {
        DeleteID: DeleteID,
        currentPage: currentPage,
        state: data.state
      };
      dispatch(setRegionDeleteActions(payload, setDeletePOPUP(false)));
    }
  };

  ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);
  useEffect(() => {
    const Datas = [];

    if (State.GeoState.State != undefined) {
      let objectArray = [];
   objectArray.push({ value: "", label: "All" });
      State.GeoState.State.forEach((element) => {
        objectArray.push({ value: element.id, label: element.state_name });
      });

      setOptions(objectArray);    }
  }, [State.GeoState.State, SearchedVal.stateSearch]);

  const handleSelectChange = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect(selectedVal)
      setData({
        ...data,
        state: selectedVal.value,
        region:""
      });
    }
    if (selectedVal == null) {
      setMuliselect([{value:"",label:"All"}])
      setData({
        ...data,
        state: "",
      });
    }
  };



  const handleNext = (next) => {    
    setdtPageindex(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
 setdtPageindex(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setdtPageindex(previous);

}
};

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };



  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
       setsearch(e);
      }, 500),
    []
  );


  
  // -----Search------------------------
  function tochange(e) {
    debouncedSearch(e);
  }



  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);


  const handlePageChange = (newPage) => {
    if (newPage < State.regioncall.Total_count) {
      setCurrentPage(newpages + 1);
      console.log(newpages, "newpagess");
      setNewpage(newPage + 1);
      const pageEntries = {
        search: search,
        page_size: 10,
        page: newPage,
      };
      dispatch(setRegionActions(pageEntries));
      console.log("New Page:", newpages);
    }
  };

  const columns = [
    {
      Header: "Region",
      accessor: "region_name",
    },
    {
      Header: "Description",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <span>
              {row.row.original.description != null &&
              row.row.original.description != "" ? (
                <span>{row.row.original.description}</span>
              ) : (
                <span>{"---"} </span>
              )}
            </span>
          </>
        );
      },
    },

    {
      Header: "Created date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <span>
              {`${
                row.row.original.created_at.slice(0, 10) + "  " + formattedTime
              }`}
            </span>
          </>
        );
      },
    },

    {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "5px",
              }}
            >
              <button
                className=" btn Status"
                onClick={(e) => {
                  setEditID(row.row.original.id);
                  setCreateRegion(true);
                }}
                component="span"
              >
                <span className="OuterActionSpan">
                <span  className="EditImages">
                    <img src={EditImages}/>
                  </span>
                  <span className="ActionsList"> Edit </span>
                </span>
              </button>

              <button
                type="button"
                class="btn Status"
                onClick={(e) => {
                  setDeleteID(row.row.original.id);
                  setDeletePOPUP(true);
                }}
              >
                <span className="OuterActionSpan">
                <span  className="EditImages">
                    <img src={DeleteImages}/>
                  </span>

                  <span className="ActionsList"> Delete </span>
                </span>
              </button>
            </div>
          </>
        );
      },
    },
  ];
  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Region</h3>

          </div>
          <div className="Add-User col-sm-5">
            <button
              onClick={(e) => {
                setCreateRegion(true);
                setEditID("");
              }}
              className="ButtonCSS"
            >
              Create
            </button>
          </div>
        </div>

        <div
          className="row Filters"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "30",
               

            marginLeft: "0px",
            marginRight: "0px",
          }}
        >
          <div className="col-sm-3">
            <label for="validationCustom01" class="form-label">
              State 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onChange={(e) => {
                 setdtPageindex(1)
                handleSelectChange(e);
              }}
              options={nameList}
              onInputChange={handleInputChange}
              labelledBy="Select"
              value={multiselect}
            />
          </div>
        </div>

        {Data != undefined ? (
          <div style={{ padding: " 0px 40px" }}>
            <ReactTable
              data={State.regioncall.RegionDat}
              columns={columns}
              totalItems={State.regioncall.Total_Count}
              currentPage={currentPage}
              // onPageChange={handlePageChange}
              onChange={tochange}
              setCurrentPage={setCurrentPage}
              pagesize={pagesize}
              onPrevious={handlePrevious}
              onNextpage={handleNext}
              GotoEnteredPage={GotoEnteredPage}
              dtpagesize={pageSize}
              dtpageindex={dtpageindex}
              pageindex={pageindex}
              datacount={State.regioncall.Total_Count}
              Oncreate={(e) => {
                setCreateRegion(true);
                setEditID("");
              }}
              Filter={true}
              NoFilter ={true}
                             searchVal={TablePositionPersist?.Overall_RegionDatas?.search == "" || TablePositionPersist?.Overall_RegionDatas?.search ==undefined? "":TablePositionPersist.Overall_RegionDatas.search}
              search_key={true}

            />
          </div>
        ) : null}
      </div>

      {CreateRegions ? (
        <RegionCreateFrom
          show={CreateRegions}
          setShow={setCreateRegion}
          currentPage={dtpageindex}
          EditId={EditId}
          search={search}
          stateID={data.state}
        />
      ) : null}

      {DeletePOPUP ? (
        <Delete
          show={DeletePOPUP}
          setShow={setDeletePOPUP}
          onSubmit={HandelDelete}
          Content={"Do you want to delete the Region"}

        />
      ) : null}
    </>
  );
};

export default Region;
